module.exports = __webpack_public_path__ + "img/268.f4b3fc57.jpg";